import { ChangeEvent } from 'react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';

import { ConditionalTooltip } from 'shared/components/Conditional';
import { PaletteColorsT } from 'shared/models/mui';

interface InputFormCheckboxProps {
  name: string;
  label: string;
  sx?: object;
  defaultChecked?: boolean;
  color?: PaletteColorsT;
  disabled?: boolean;
  control: Control<any, object>;
  // eslint-disable-next-line no-unused-vars
  onChange?: ((event: ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
  helpText?: string;
}
function InputFormCheckbox({
  name,
  label,
  defaultChecked,
  sx,
  color,
  disabled,
  control,
  onChange,
  helpText,
}: InputFormCheckboxProps) {
  return (
    <FormControl>
      <ConditionalTooltip title={helpText} placement="right">
        <FormControlLabel
          label={label}
          sx={sx}
          control={(
            <Controller
              control={control}
              name={name}
              defaultValue={defaultChecked || false}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  color={color}
                  onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
                    if (onChange) onChange(event, checked);
                    field.onChange(event);
                  }}
                  disabled={disabled}
                  checked={field.value}
                />
              )}
            />
            )}
        />
      </ConditionalTooltip>
    </FormControl>
  );
}

export default InputFormCheckbox;
